import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthProvider";

const HomePage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  useEffect(() => {
    // Check if user is logged in when component mounts
    if (user) {
      setIsLoggedIn(true);
    }
  }, [user]);

  const startPlay = () => {
    navigate("/aattam");
  };
  
  const handleRigistration = () => {
    navigate("/registration");
  };
  
  const handleLogin = () => {
    const userStr = localStorage.getItem("user");
    const user = userStr ? JSON.parse(userStr) : null;
    // Check if user is authenticated and has required role
    const isAuthenticated = !!user;
    if (!isAuthenticated) {
      navigate("/login");
    } else {
      navigate("/aattam");
    }
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row items-center justify-center bg-gradient-to-bl from-[#0f172a] via-[#1e1a78] to-[#0f172a] text-white p-4 md:p-6 lg:p-8">
      <div className="w-full md:w-1/2 flex justify-center mb-6 md:mb-0">
        <img
          src="/images/valluvar-1.png"
          alt="Thiruvalluvar Line Drawing"
          className="w-3/4 md:w-4/5 lg:w-4/5 xl:w-full h-auto object-contain max-w-2xl"
        />
      </div>
      <div className="w-full md:w-1/2 flex flex-col items-center text-center md:text-left px-4 md:px-8 lg:px-12">
        <motion.h1
          className="text-5xl md:text-7xl lg:text-9xl font-bold mb-2 md:mb-4 "
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          குறளாட்டம்
        </motion.h1>

        <motion.h1
          className="text-3xl md:text-4xl lg:text-6xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-green-500 via-yellow-400 to-orange-600 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          கொண்டாட்டம்
        </motion.h1>

        <motion.p
          className="text-base md:text-lg max-w-lg mb-6 px-4 md:px-0"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          திருக்குறள் சீர்களை சரியான வரிசையில் அமைத்து அர்த்தமுள்ள குறள்களை
          உருவாக்குங்கள்! உங்கள் திருக்குறள் திறனை மேம்படுத்தி, மகிழ்ச்சியுடன்
          விளையாடுங்கள்!
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="w-full flex justify-center"
        >
          {isLoggedIn ? (
            <button
              onClick={startPlay}
              className="w-48 px-6 py-3 text-base md:text-lg font-semibold rounded-xl bg-yellow-400 hover:bg-yellow-500 text-gray-900 shadow-lg transform hover:scale-105 transition-transform duration-200"
            >
              Start Playing
            </button>
          ) : (
            <>
              <button
                onClick={handleLogin}
                className="w-32 px-6 py-3 text-base md:text-lg font-semibold rounded-xl bg-yellow-400 hover:bg-yellow-500 text-gray-900 shadow-lg transform hover:scale-105 transition-transform duration-200"
              >
                Login
              </button>
              <button
                onClick={handleRigistration}
                className="w-32 px-6 py-3 ml-2 text-base md:text-lg font-semibold rounded-xl bg-yellow-400 hover:bg-yellow-500 text-gray-900 shadow-lg transform hover:scale-105 transition-transform duration-200"
              >
                Register
              </button>
            </>
          )}
        </motion.div>
        <div className="mt-4 flex flex-col items-center">
          <h2 className="text-sm font-semibold mt-4 text-stone-300">
            This Game Powered By
          </h2>
          <motion.img
            onClick={startPlay}
            src={process.env.PUBLIC_URL + "/images/logo.svg"}
            alt="Vetri Logo"
            className="w-32 md:w-40 lg:w-48 h-auto object-contain"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
